const Approvals = () => import("../leave/views/Approvals.vue");
const LeaveForm = () => import("../leave/views/LeaveForm.vue");
const MyLeaves = () => import("../leave/views/MyLeaves.vue");
const EditLeaveForm = () => import("../leave/views/EditLeaveForm.vue");

export default [
  {
    path: "approvals",
    component: Approvals,
  },
  {
    path: "create",
    component: LeaveForm,
  },
  {
    name: "edit-leave",
    path: "edit/:id",
    component: EditLeaveForm,
  },
  {
    path: "my-leaves",
    component: MyLeaves,
  },
];
